import React from 'react'
import { customSVGProps } from '../../Material/SvgIcon'
import { SvgIcon } from '@mui/material'

// Exemplo de SVG personalizado (substitua pelo seu próprio SVG)
export const BbLogoIcon = (props: customSVGProps & { colors?: string }) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1033 16.5315L8.10315 15.187L17.6129 8.76168L11.7419 4.80537L8.98072 6.6671L11.1227 8.08919L6.18071 11.399L2.03885 8.65803L12.0124 2.00012L21.9092 8.63224L10.1033 16.5315ZM13.8581 7.41695L15.858 8.76168L6.3485 15.187L12.2321 19.143L14.9945 17.2818L12.8526 15.8726L17.8064 12.5625L21.9488 15.3033L11.9488 21.9488L2.07746 15.3422L13.8581 7.41695ZM6.10325 19.3112L4.06449 17.9149L2 19.3112L2.02475 22.0001L6.10325 19.3112ZM17.9482 4.7409L19.9999 6.1372L22 4.80537V2.0517L17.9482 4.7409Z"
        fill={props.colors ?? 'white'}
      />
    </svg>
  </SvgIcon>
)
